import { useLanguage } from "../contexts/LanguageContext"

export default function DownloadCTA() {
  const { t, currentLanguage } = useLanguage()

  // Function to get the appropriate signup image based on language
  const getLanguageSignupImage = () => {
    const languageImageMap = {
      en: "/en_signup.jpg",
      hi: "/hi_signup.jpg",
      ar: "/ar_sighup.jpg",
      ur: "/urdu_signup.jpg",
      fr: "/french_signup.jpg",
      ko: "/korian_signup.jpg",
      filipino: "/filipino_signup.jpg",
      persian: "/pr_signup.jpg",
      pashto: "/pasto_signup.jpg"
    }

    return languageImageMap[currentLanguage] || languageImageMap.en
  }

  return (
    <section id="download" className="py-16 md:py-20 lg:py-24 pb-20 md:pb-24 lg:pb-32 bg-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        <div className="grid lg:grid-cols-2 gap-8 md:gap-12 lg:gap-16 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h2 className="text-2xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold mb-4 md:mb-6 leading-tight">
              {t("download.title")}
            </h2>
            {/* <p className="text-lg md:text-xl text-gray-300">
              {t("download.subtitle")}
            </p> */}

            <div className="flex flex-col sm:flex-row sm:gap-4 md:gap-6 justify-center lg:justify-start items-center">
              <a
                href="https://play.google.com/store/apps/details?id=net.app.makkok"
                className="hover:opacity-80 transition-opacity duration-200 -mb-4 sm:mb-0"
              >
                <img
                  src="/google-play-badge-logo-svgrepo-com.svg"
                  alt="Get it on Google Play"
                  className="h-32 md:h-32 lg:h-40 w-auto"
                />
              </a>

              <a
                href="https://apps.apple.com/sa/app/makkok/id6739888182"
                className="hover:opacity-80 transition-opacity duration-200 -mb-4 sm:mb-0"
              >
                <img
                  src="/download-on-the-app-store-apple-logo-svgrepo-com.svg"
                  alt="Download on the App Store"
                  className="h-32 md:h-32 lg:h-40 w-auto"
                />
              </a>
            </div>
          </div>

          {/* Right Phone Mockups */}
          <div className="relative flex justify-center lg:justify-end items-center order-1 lg:order-2 mt-8 lg:mt-0 max-w-full">
            {/* First Phone - Hidden on mobile */}
            <div className="relative z-10 mr-2 md:mr-4 lg:mr-6 hidden md:block">
              <div className="bg-gray-900 rounded-[1.5rem] md:rounded-[2rem] lg:rounded-[2.5rem] p-1 md:p-2 shadow-2xl transform rotate-[-6deg] md:rotate-[-8deg] hover:rotate-[-3deg] md:hover:rotate-[-4deg] transition-transform duration-300">
                <div className="rounded-[1.25rem] md:rounded-[1.75rem] lg:rounded-[2rem] overflow-hidden h-[280px] md:h-[400px] lg:h-[500px] w-[140px] md:w-[200px] lg:w-[250px]">
                  <img
                    src="/222.png"
                    alt="Makkok Mobile App Interface - First Screen"
                    className="w-full h-full object-fill"
                  />
                </div>
              </div>
            </div>

            {/* Second Phone - Centered on mobile, positioned normally on larger screens */}
            <div className="relative z-20 mx-auto md:mx-0">
              <div className="bg-gray-900 rounded-[1.5rem] md:rounded-[2rem] lg:rounded-[2.5rem] p-1 md:p-2 shadow-2xl transform rotate-0 md:rotate-[6deg] md:rotate-[8deg] hover:rotate-[2deg] md:hover:rotate-[3deg] md:hover:rotate-[4deg] transition-transform duration-300">
                <div className="rounded-[1.25rem] md:rounded-[1.75rem] lg:rounded-[2rem] overflow-hidden h-[280px] md:h-[400px] lg:h-[500px] w-[140px] md:w-[200px] lg:w-[250px]">
                  <img
                    src={getLanguageSignupImage()}
                    alt="Makkok Mobile App Interface - Second Screen"
                    className="w-full h-full object-fill"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
